module.exports = __webpack_public_path__ + "img/crfi.0f88cf9c.png";